class RecentlySold extends HTMLElement {
  constructor() {
    super();
    fetch(this.dataset.url)
      .then(response => response.json())
      .then(json => {
        // Round the prices before rendering
        json.items = json.items.map(item => ({
          ...item,
          soldPrice: Math.round(item.soldPrice)
        }));
        const template = document.getElementById("items-template").innerHTML;
        const renderItems = Handlebars.compile(template);
        document.getElementById("recommendationsSpinner").style.display = 'none';
        document.getElementById("recommendations-list").innerHTML = renderItems(json);
      })
      .catch(e => {
        console.error(e);
        document.getElementById('recently-sold-wrapper').style.display = 'none';
      });
  }
}
customElements.define('recently-sold', RecentlySold);